import {PathwaysTrigger, PrefetchDataActionTypes} from '@ispm/test/store/prefetch-data/prefetch-data.actions';
import {initialState} from '@ispm-client/modules/pathways/store/state';


export function pathwaysIsPrefetched(state = initialState.pathwaysIsPrefetched,
                                    action: PathwaysTrigger): any {
  switch (action.type) {
    case PrefetchDataActionTypes.PATHWAYS_TRIGGER_ON: {
      return true;
    }
    case PrefetchDataActionTypes.PATHWAYS_TRIGGER_OFF: {
      return false;
    }
    default:
      return state;
  }
}
